import { nombreDeUsuario } from "./nombreUsuario";

export const textoUltimoMensaje = (ticket, usuarioId) => {
  const texto = ticket?.ultimoMensajeTexto;
  if (!texto) return "";
  if (ticket.ultimoMensajeEsSistema) return texto;

  const autorId = ticket.ultimoMensajeUsuarioId?._id || ticket.ultimoMensajeUsuarioId;
  if (!autorId && !ticket.ultimoMensajeEsAgente) return texto;

  const propio = !!autorId && String(autorId) === String(usuarioId);

  let autor;
  if (propio) autor = "Tú";
  else if (ticket.ultimoMensajeEsAgente) autor = "Soporte Biwo";
  else autor = nombreDeUsuario(ticket.ultimoMensajeUsuarioId, "Cliente");

  return `${autor}: ${texto}`;
};

export default textoUltimoMensaje;
